import { component$ } from "@builder.io/qwik";
import { cn } from "~/utils/tailwind-helper";

export const IconArrowDown = component$<{ class?: string }>(({ class: className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            class={cn(className)}
        >
            <path
                d="M7.99967 3.33301V12.6663M7.99967 12.6663L12.6663 7.99967M7.99967 12.6663L3.33301 7.99967"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
});
